/**
 * Retrieves the party id used by flows to identify the session
 * @returns The party id included in the url
 */
const usePartyId = (): string | undefined => {
  return getPartyIdParam();
};

export const getPartyIdParam = (): string => {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  const party_id = params.get('party_id');
  if (party_id && typeof party_id === 'string') {
    return party_id;
  }

  const partyId = params.get('partyId');
  if (partyId && typeof partyId === 'string') {
    return partyId;
  }

  return '';
};

export default usePartyId;
